class SmallHeroScroll {
  constructor(smallHero) {
    this.smallHero = smallHero;
    this.navbar = document.querySelector('#navbar');
    this.wrapper = document.querySelector('.wrapper');
  }

  init() {
    this.setScrolledClass();

    window.addEventListener('scroll', () => {
      this.setScrolledClass();
    });

    window.addEventListener('resize', () => {
      this.setScrolledClass();
    });
  }

  setScrolledClass() {
    const windowHeight = window.innerHeight;
    let scrolledHeight = windowHeight / 4;
    let unscrolledHeight = windowHeight / 2;
    if (windowHeight / 4 < 240) {
      scrolledHeight = 240;
    }

    if (windowHeight / 2 < 460) {
      unscrolledHeight = 460;
    }

    if (window.innerWidth > 1200) {
      this.navbar.classList.add('js-small-hero');
      if (window.pageYOffset > 0) {
        this.smallHero.classList.add('js-scrolled');
        this.wrapper.style.paddingTop = `${scrolledHeight}px`;
      } else {
        this.smallHero.classList.remove('js-scrolled');
        this.wrapper.style.paddingTop = `${unscrolledHeight}px`;
      }
    } else {
      this.navbar.classList.remove('js-small-hero');
      this.smallHero.classList.remove('js-scrolled');
      this.wrapper.style.paddingTop = 0;
    }
  }
}

export default SmallHeroScroll;